import sectionMedia from '@sections/media'
import { Http } from 'sparnord-utils'
import abstract from './abstract'

export default class extends abstract {
  getComponent () {
    return sectionMedia
  }

  get thumbnail () {
    this.item.properties.video = this.item.properties.video || {properties: {}}

    let thumbnail = this.item.properties.thumbnail || this.item.properties.video.properties.thumbnail
    return thumbnail instanceof Array || !thumbnail ? null : Http.Api.root + thumbnail.url
  }

  get src () {
    this.item.properties.video = this.item.properties.video || {properties: {}}

    let src = this.item.properties.link || this.item.properties.video.properties.link
    return src instanceof Array || !src ? null : src
  }

  get description () {
    return this.item.properties.tekst
  }

  get link () {
    return this.item.properties.link || this.item.properties.linkTil
  }

  get route () {
    return this.item.properties.linkTilIntern ? this.item.properties.linkTilIntern.url : null
  }

  get cta () {
    return this.item.properties.linkTekst || this.item.name
  }
}



// WEBPACK FOOTER //
// ./src/models/sections/video.js